<div class="map-filter-overlay" *ngIf="isOpen" (click)="close()">
  <div class="filter-sheet filter-popup-center" [class.filter-sheet--tuner]="sheetMode === 'tuner'" (click)="$event.stopPropagation()">

  <!-- ════════════════════════════════════════════════════════════════════════
       FULL-SCREEN CALENDAR VIEW
       ════════════════════════════════════════════════════════════════════════ -->
  <div class="cal-fullscreen" *ngIf="showCalendar">
    <div class="cal-topbar">
      <button class="cal-close-btn" (click)="closeCalendar()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <span class="cal-title">SELECT DATE RANGE</span>
      <button class="cal-save-btn" (click)="saveCalendar()">Save</button>
    </div>
    <div class="cal-range-display">
      {{ getFullDateRange() }}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-left:8px">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
      </svg>
    </div>
    <div class="cal-body">
      <mat-calendar [selected]="activeRange" [minDate]="minDate" [maxDate]="maxDate" (selectedChange)="onDateSelected($event)">
      </mat-calendar>
    </div>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════════
       SAVE FILTER MODAL
       ════════════════════════════════════════════════════════════════════════ -->
  <div class="modal-dialog-overlay" *ngIf="showSaveModal" (click)="closeSaveModal()">
    <div class="save-filter-modal-card" (click)="$event.stopPropagation()">
      <div class="modal-title-row">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
          <line x1="12" y1="9" x2="12" y2="15"></line>
          <line x1="9" y1="12" x2="15" y2="12"></line>
        </svg>
        <span>Save as filter</span>
      </div>
      <div class="modal-desc">Give this customized map filter a unique name to quickly access it from presets.</div>
      <input type="text" class="save-filter-input" [(ngModel)]="saveFilterInputName" placeholder="Filter Name" autofocus (keydown.enter)="confirmSaveFilter()">
      <div class="modal-btn-row">
        <button type="button" class="modal-btn-cancel" (click)="closeSaveModal()">Cancel</button>
        <button type="button" class="modal-btn-confirm" (click)="confirmSaveFilter()">Save Filter</button>
      </div>
    </div>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════════
       MAIN SHEET CONTENT
       ════════════════════════════════════════════════════════════════════════ -->
  <ng-container *ngIf="!showCalendar">

    <!-- ── Header in PICKER Mode ───────────────────────────────────────────── -->
    <div class="sheet-header" *ngIf="sheetMode === 'picker'">
      <button class="hdr-btn hdr-btn--close" (click)="close()" aria-label="Close">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3C3C43" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <h2 class="sheet-title">Map Display</h2>
      <button class="hdr-btn hdr-btn--apply" [appTourAnchor]="'filters.mapApply'" (click)="applyFilter()" aria-label="Apply">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </button>
    </div>

    <!-- ── Header in TUNER Mode (with Back chevron to return to picker) ────── -->
    <div class="sheet-header sheet-header--tuner" *ngIf="sheetMode === 'tuner'">
      <button class="hdr-btn hdr-btn--back" (click)="backToPicker()" aria-label="Back to presets">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3C3C43" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <div class="tuner-title-wrap">
        <h2 class="sheet-title">{{ activePresetName }}</h2>
        <span class="sheet-subtitle">Tune filter facets</span>
      </div>
      <button class="hdr-btn hdr-btn--apply" (click)="backToPicker()" aria-label="Done">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </button>
    </div>

    <!-- ── Top Segmented Control (Map Filters vs Map Styles) in PICKER Mode ── -->
    <div class="segmented-control-wrapper" *ngIf="sheetMode === 'picker'">
      <div class="segmented-control">
        <button type="button" class="segment-btn" [class.active]="activeDisplayTab === 'filters'"
          (click)="switchDisplayTab('filters')">
          <svg class="segment-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
          <span>Map Filters</span>
        </button>
        <button type="button" class="segment-btn" [class.active]="activeDisplayTab === 'styles'"
          (click)="switchDisplayTab('styles')">
          <svg class="segment-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
            <polyline points="2 17 12 22 22 17"></polyline>
            <polyline points="2 12 12 17 22 12"></polyline>
          </svg>
          <span>Map Styles</span>
        </button>
      </div>
    </div>

    <!-- ── 3-way Segmented Control (When · What · Who) in TUNER Mode ───────── -->
    <div class="segmented-control-wrapper" *ngIf="sheetMode === 'tuner'">
      <div class="segmented-control tuner-segments">
        <button type="button" class="segment-btn" [class.active]="tunerTab === 'when'"
          (click)="switchTunerTab('when')">
          <svg class="segment-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
          <span>When</span>
        </button>
        <button type="button" class="segment-btn" [class.active]="tunerTab === 'what'"
          (click)="switchTunerTab('what')">
          <svg class="segment-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span>What</span>
        </button>
        <button type="button" class="segment-btn" [class.active]="tunerTab === 'who'"
          (click)="switchTunerTab('who')">
          <svg class="segment-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
          <span>Who</span>
        </button>
      </div>
    </div>

    <!-- ════════════════════════════════════════════════════════════════════════
         TAB: MAP STYLES
         ════════════════════════════════════════════════════════════════════════ -->
    <div class="tab-scroll-body" *ngIf="sheetMode === 'picker' && activeDisplayTab === 'styles'">
      <div class="map-styles-tab-content">
        <div class="section-label-caption">Tap a chart to redraw the map · applies everywhere</div>

        <div class="map-skin-card">
          <div class="skin-tiles-grid">
            <div *ngFor="let skin of skinsCatalog.classic" class="skin-tile"
              [class.selected]="selectedSkinId === skin.id"
              (click)="selectSkin(skin.id)">
              <div class="skin-thumbnail-wrap">
                <img [src]="skin.thumbnail" [alt]="skin.label" class="skin-thumbnail" />
                <div *ngIf="selectedSkinId === skin.id" class="skin-selected-badge">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
              </div>
              <div class="skin-label" [class.selected]="selectedSkinId === skin.id">{{ skin.label }}</div>
            </div>
          </div>

          <div class="skin-divider"></div>

          <!-- Description of selected skin -->
          <div class="skin-description-row">
            <span class="skin-desc-name">{{ currentSkin.label }} — </span>
            <span class="skin-desc-text">{{ currentSkin.description }}</span>
          </div>
        </div>

        <div class="skin-attribution">
          © MapTiler © OpenStreetMap contributors
        </div>
      </div>

      <!-- Reset map style footer -->
      <div class="sheet-footer">
        <button class="reset-btn" (click)="resetSkin()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"></polyline>
            <polyline points="1 20 1 14 7 14"></polyline>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
          </svg>
          <span>Reset Map Style</span>
        </button>
      </div>
    </div>

    <!-- ════════════════════════════════════════════════════════════════════════
         VIEW 1: PICKER MODE (Compact Preset Chips + More Options Card)
         ════════════════════════════════════════════════════════════════════════ -->
    <div class="tab-scroll-body" *ngIf="sheetMode === 'picker' && activeDisplayTab === 'filters'">

      <!-- Fast Presets Chips Section -->
      <div class="presets-section">
        <div class="section-label-caption">Tap to show on the map · hold to edit</div>
        <div class="presets-chips-row">
          <!-- Built-in chips -->
          <button type="button" *ngFor="let p of builtInPresets" class="preset-chip"
            [class.selected]="selectedPresetId === p.id"
            (click)="applyPreset(p.id)">
            <svg *ngIf="selectedPresetId === p.id" class="chip-check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#007AFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>{{ p.label }}</span>
          </button>

        </div>
      </div>

      <!-- ── "More options to <active preset>" Card (Mirrors Mobile App) ──────── -->
      <div class="more-options-wrapper">
        <button type="button" class="more-options-card" (click)="openTuner()">
          <div class="mo-icon-wrap">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#007AFF" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round">
              <line x1="4" y1="21" x2="4" y2="14"></line>
              <line x1="4" y1="10" x2="4" y2="3"></line>
              <line x1="12" y1="21" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12" y2="3"></line>
              <line x1="20" y1="21" x2="20" y2="16"></line>
              <line x1="20" y1="12" x2="20" y2="3"></line>
              <line x1="1" y1="14" x2="7" y2="14"></line>
              <line x1="9" y1="8" x2="15" y2="8"></line>
              <line x1="17" y1="16" x2="23" y2="16"></line>
            </svg>
          </div>
          <div class="mo-text-wrap">
            <span class="mo-title">More options</span>
            <span class="mo-subtitle">to {{ activePresetName }}</span>
          </div>
          <svg class="mo-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>

      <!-- ── Reset Filter Footer ───────────────────────────────────────────── -->
      <div class="sheet-footer">
        <button class="reset-btn" (click)="resetFilters()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"></polyline>
            <polyline points="1 20 1 14 7 14"></polyline>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
          </svg>
          <span>Reset filter</span>
        </button>
      </div>

    </div>

    <!-- ════════════════════════════════════════════════════════════════════════
         VIEW 2: TUNER MODE (WHEN · WHAT · WHO)
         ════════════════════════════════════════════════════════════════════════ -->
    <div class="tab-scroll-body tuner-scroll-body" *ngIf="sheetMode === 'tuner'">

      <!-- ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
           TUNER TAB 1: WHEN
           ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ -->
      <div class="tuner-tab-content" *ngIf="tunerTab === 'when'">

        <!-- Quick picks -->
        <div class="section-label">QUICK PICKS</div>
        <div class="tuner-chips-row">
          <button type="button" class="preset-chip" [class.selected]="whenQuickPick === 'today'" (click)="applyWhenQuickPick('today')">
            <svg *ngIf="whenQuickPick === 'today'" class="chip-check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#007AFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <svg *ngIf="whenQuickPick !== 'today'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:4px">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span>Today</span>
          </button>

          <button type="button" class="preset-chip" [class.selected]="whenQuickPick === '2days'" (click)="applyWhenQuickPick('2days')">
            <svg *ngIf="whenQuickPick === '2days'" class="chip-check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#007AFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <svg *ngIf="whenQuickPick !== '2days'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:4px">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span>2 days</span>
          </button>

          <button type="button" class="preset-chip" [class.selected]="whenQuickPick === 'week'" (click)="applyWhenQuickPick('week')">
            <svg *ngIf="whenQuickPick === 'week'" class="chip-check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#007AFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <svg *ngIf="whenQuickPick !== 'week'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:4px">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span>Week</span>
          </button>

          <button type="button" class="preset-chip" [class.selected]="whenQuickPick === 'month'" (click)="applyWhenQuickPick('month')">
            <svg *ngIf="whenQuickPick === 'month'" class="chip-check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#007AFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <svg *ngIf="whenQuickPick !== 'month'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:4px">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            <span>Month</span>
          </button>
        </div>

        <!-- Custom Date range card -->
        <div class="section-label" style="margin-top: 18px;">DATE RANGE</div>
        <div class="date-picker-card" (click)="openCalendar()">
          <div class="dpc-icon-wrap">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
          </div>
          <div class="dpc-text-wrap">
            <span class="dpc-range">{{ formatRange(selectedTrackLinesRange) }}</span>
            <span class="dpc-hint">Tap to select custom date range</span>
          </div>
          <svg class="dpc-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C7C7CC" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <div class="section-caption-muted">Up to one month at a time.</div>

        <!-- Active trips only toggle row -->
        <div class="tuner-switch-card" style="margin-top: 18px;">
          <div class="tsc-left">
            <span class="tsc-title">Active trips only</span>
            <span class="tsc-desc">Show vessels currently on the water</span>
          </div>
          <label class="ios-toggle">
            <input type="checkbox" [(ngModel)]="activeTripsOnly" (ngModelChange)="selectedPresetId = activeTripsOnly ? 'live' : 'custom'">
            <span class="slider"></span>
          </label>
        </div>

      </div>

      <!-- ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
           TUNER TAB 2: WHAT
           ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ -->
      <div class="tuner-tab-content" *ngIf="tunerTab === 'what'">

        <!-- TRIPS SECTION -->
        <div class="section-label">TRIPS</div>
        <div class="tuner-list-card">
          <div class="tl-header-row" (click)="tripsExpanded = !tripsExpanded">
            <div class="sq-check" [class.checked]="!activeTripsOnly" [class.indeterminate]="activeTripsOnly" (click)="$event.stopPropagation(); toggleAllTripsCompleted()">
              <svg *ngIf="!activeTripsOnly" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <svg *ngIf="activeTripsOnly" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
            </div>
            <span class="tl-title">All Trips</span>
            <svg class="row-chevron" [class.expanded]="tripsExpanded" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2.5" stroke-linecap="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>

          <div class="tl-sub-rows" *ngIf="tripsExpanded">
            <div class="tl-sub-row">
              <div class="sq-check checked disabled">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <span class="tl-sub-label">In progress</span>
            </div>
            <div class="tl-sub-row" (click)="toggleAllTripsCompleted()">
              <div class="sq-check" [class.checked]="!activeTripsOnly">
                <svg *ngIf="!activeTripsOnly" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <span class="tl-sub-label">Completed</span>
            </div>
          </div>
        </div>

        <!-- WAYPOINTS MASTER TOGGLE -->
        <div class="section-label" style="margin-top: 18px;">WAYPOINTS</div>
        <div class="tuner-switch-card">
          <div class="tsc-left">
            <span class="tsc-title">Show waypoints</span>
            <span class="tsc-desc">Off hides every pin, whatever is picked below</span>
          </div>
          <label class="ios-toggle">
            <input type="checkbox" [(ngModel)]="waypointsEnabled">
            <span class="slider"></span>
          </label>
        </div>

        <!-- EVENTS (When waypoints enabled) -->
        <ng-container *ngIf="waypointsEnabled">
          <div class="section-label" style="margin-top: 18px;">EVENTS</div>
          <div class="tuner-list-card">
            <div class="tl-header-row" (click)="eventsExpanded = !eventsExpanded">
              <div class="sq-check" [class.checked]="selectedEvents.size === eventPills.length" (click)="$event.stopPropagation(); toggleAllEvents()">
                <svg *ngIf="selectedEvents.size > 0" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <span class="tl-title">All Events</span>
              <svg class="row-chevron" [class.expanded]="eventsExpanded" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2.5" stroke-linecap="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>

            <div class="tl-pills-wrap" *ngIf="eventsExpanded">
              <button *ngFor="let p of eventPills" class="pill" [class.selected]="selectedEvents.has(p)" (click)="togglePill(selectedEvents, p)">
                <mat-icon class="pill-icon">{{ eventIcons[p] }}</mat-icon>
                <span>{{ p }}</span>
              </button>
            </div>
          </div>

          <!-- Tuna Subtypes if Tuna Caught selected -->
          <ng-container *ngIf="selectedEvents.has('Tuna Caught')">
            <div class="section-label-sub">Tuna Types</div>
            <div class="pill-group">
              <button *ngFor="let p of tunaTypePills" class="pill" [class.selected]="selectedTunaTypes.has(p)" (click)="togglePill(selectedTunaTypes, p)">{{ p }}</button>
            </div>
          </ng-container>

          <!-- Billfish Subtypes if Billfish Caught selected -->
          <ng-container *ngIf="selectedEvents.has('Billfish Caught')">
            <div class="section-label-sub">Billfish Types</div>
            <div class="pill-group">
              <button *ngFor="let p of billfishPills" class="pill" [class.selected]="selectedBillfish.has(p)" (click)="togglePill(selectedBillfish, p)">{{ p }}</button>
            </div>
          </ng-container>

          <!-- Pelagic Subtypes if Pelagic Caught selected -->
          <ng-container *ngIf="selectedEvents.has('Pelagic Caught')">
            <div class="section-label-sub">Pelagic Types</div>
            <div class="pill-group">
              <button *ngFor="let p of pelagicPills" class="pill" [class.selected]="selectedPelagic.has(p)" (click)="togglePill(selectedPelagic, p)">{{ p }}</button>
            </div>
          </ng-container>

          <!-- Inshore Subtypes if Inshore Caught selected -->
          <ng-container *ngIf="selectedEvents.has('Inshore Caught')">
            <div class="section-label-sub">Inshore Types</div>
            <div class="pill-group">
              <button *ngFor="let p of inshoreTypePills" class="pill" [class.selected]="selectedInshore.has(p)" (click)="togglePill(selectedInshore, p)">{{ p }}</button>
            </div>
          </ng-container>

          <!-- PLACES -->
          <div class="section-label" style="margin-top: 18px;">PLACES</div>
          <div class="pill-group">
            <button *ngFor="let p of placePills" class="pill" [class.selected]="selectedPlaces.has(p)" (click)="togglePill(selectedPlaces, p)">
              <mat-icon class="pill-icon">{{ placeIcons[p] }}</mat-icon>
              <span>{{ p }}</span>
            </button>
          </div>

          <!-- ALERTS -->
          <div class="section-label" style="margin-top: 18px;">ALERTS</div>
          <div class="pill-group">
            <button *ngFor="let p of alertPills" class="pill" [class.selected]="selectedAlerts.has(p)" (click)="togglePill(selectedAlerts, p)">
              <mat-icon class="pill-icon">{{ alertIcons[p] }}</mat-icon>
              <span>{{ p }}</span>
            </button>
          </div>
        </ng-container>

      </div>

      <!-- ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
           TUNER TAB 3: WHO
           ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ -->
      <div class="tuner-tab-content" *ngIf="tunerTab === 'who'">

        <!-- SOURCES -->
        <div class="section-label">SOURCES</div>

        <!-- Me -->
        <div class="vis-card" (click)="mineEnabled = !mineEnabled">
          <div class="sq-check" [class.checked]="mineEnabled">
            <svg *ngIf="mineEnabled" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <span class="vis-card-label">Me</span>
        </div>

        <!-- Public -->
        <div class="vis-card" (click)="togglePublic()">
          <div class="sq-check" [class.checked]="publicEnabled">
            <svg *ngIf="publicEnabled" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <span class="vis-card-label">Public</span>
        </div>

        <!-- GROUPS -->
        <div class="vis-card" (click)="expandFleets = !expandFleets">
          <div class="sq-check" [class.checked]="allFleetsVisible" [class.indeterminate]="someFleetsVisible"
            (click)="$event.stopPropagation(); toggleAllFleets()">
            <svg *ngIf="allFleetsVisible" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <svg *ngIf="someFleetsVisible" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </div>
          <span class="vis-card-label">Groups</span>
          <svg class="row-chevron" [class.expanded]="expandFleets" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2.5" stroke-linecap="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>

        <div class="vis-expand" *ngIf="expandFleets">
          <div class="search-field">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2" stroke-linecap="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input class="search-input" type="text" [(ngModel)]="groupSearchQuery" placeholder="Search Groups">
          </div>

          <div class="loading-row" *ngIf="loadingFleets"><span>Loading…</span></div>

          <div class="vis-list" *ngIf="!loadingFleets && filteredFleets.length > 0">
            <div class="vis-list-row" *ngFor="let fleet of filteredFleets" (click)="toggleFleet(fleet)">
              <div class="sq-check" [class.checked]="isFleetVisible(fleet)">
                <svg *ngIf="isFleetVisible(fleet)" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div class="community-avatar">
                <img *ngIf="fleet.image_url" [src]="fleet.image_url" class="avatar-img" [alt]="fleet.name">
                <span *ngIf="!fleet.image_url" class="avatar-initials">{{ getInitials(fleet.name) }}</span>
              </div>
              <div class="community-info">
                <span class="community-name">{{ fleet.name }}</span>
                <span class="community-sub" *ngIf="fleet.members_count">{{ fleet.members_count }} members</span>
              </div>
            </div>
          </div>

          <div class="vis-empty" *ngIf="!loadingFleets && filteredFleets.length === 0">
            <span>{{ groupSearchQuery.trim() ? 'No matching groups' : 'No groups found' }}</span>
          </div>
        </div>

        <!-- CAPTAINS -->
        <div class="vis-card" (click)="expandCaptains = !expandCaptains">
          <div class="sq-check" [class.checked]="allCaptainsVisible" [class.indeterminate]="someCaptainsVisible"
            (click)="$event.stopPropagation(); toggleAllCaptains()">
            <svg *ngIf="allCaptainsVisible" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <svg *ngIf="someCaptainsVisible" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </div>
          <span class="vis-card-label">Captains</span>
          <svg class="row-chevron" [class.expanded]="expandCaptains" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2.5" stroke-linecap="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>

        <div class="vis-expand" *ngIf="expandCaptains">
          <div class="search-field">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" stroke-width="2" stroke-linecap="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input class="search-input" type="text" [(ngModel)]="captainSearchQuery" placeholder="Search Captains">
          </div>

          <div class="loading-row" *ngIf="loadingRoster && roster.length === 0"><span>Loading…</span></div>

          <div class="vis-list" *ngIf="filteredRoster.length > 0">
            <div class="vis-list-row" *ngFor="let cap of displayedCaptains" (click)="toggleCaptain(cap)">
              <div class="sq-check" [class.checked]="captainChecked(cap)">
                <svg *ngIf="captainChecked(cap)" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <div class="community-avatar">
                <img *ngIf="cap.avatarUrl" [src]="cap.avatarUrl" class="avatar-img" [alt]="cap.name">
                <span *ngIf="!cap.avatarUrl" class="avatar-initials">{{ getInitials(cap.name) }}</span>
              </div>
              <div class="community-info">
                <span class="community-name">{{ cap.name }}</span>
                <span class="community-sub" *ngIf="cap.vesselName">{{ cap.vesselName }}</span>
              </div>
            </div>

            <div class="vis-overflow-row" *ngIf="captainOverflow > 0">
              +{{ captainOverflow }} more · search to find them
            </div>
          </div>

          <div class="vis-empty" *ngIf="!loadingRoster && filteredRoster.length === 0">
            <span>{{ captainSearchQuery.trim() ? 'No matching captains' : 'No captains visible on the map' }}</span>
          </div>
        </div>

      </div>

      <!-- ── TUNER FOOTER (Reset + Save as filter options) ──────────────────── -->
      <div class="sheet-footer sheet-footer--tuner">
        <button type="button" class="tuner-footer-btn tuner-reset-btn" (click)="resetFilters()">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"></polyline>
            <polyline points="1 20 1 14 7 14"></polyline>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
          </svg>
          <span>Reset</span>
        </button>

        <button type="button" *ngIf="editingSavedId" class="tuner-footer-btn tuner-delete-btn" (click)="deleteCurrentSavedFilter()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
          <span>Delete</span>
        </button>

        <button type="button" class="tuner-footer-btn tuner-save-btn" (click)="openSaveModal()">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
            <line x1="12" y1="8" x2="12" y2="14"></line>
            <line x1="9" y1="11" x2="15" y2="11"></line>
          </svg>
          <span>Save as filter</span>
        </button>
      </div>

    </div>

  </ng-container><!-- end main sheet -->
  </div>
</div>